"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericErrorMessageWrapper = void 0;
var React = require("react");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../selectors");
var GenericErrorMessageWrapper = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var dispatchers = mapDispatchToProps(dispatch);
    var selectors = (0, selectors_1.mapSelectors)();
    return (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                return selectors.values.orderId &&
                    dispatchers.fetchOrderFiles(selectors.values.orderId, props.mode);
            }, children: (0, translation_1.getLocalization)('generic/tryAgain') })));
};
exports.GenericErrorMessageWrapper = GenericErrorMessageWrapper;
var mapDispatchToProps = function (dispatch) { return ({
    fetchOrderFiles: function (id, mode) {
        return dispatch(WizardActions.fetchOrderFilesRequest(id, mode));
    }
}); };
